import { apiClient } from '../apiClient';

export const getContacts = async () => {
  const response = await apiClient.get('/contacts');
  return response.data;
};

export const getContactFormMeta = async () => {
  const response = await apiClient.get('/contacts/meta/form');
  return response.data;
};

export const addContact = async (contactData) => {
  const response = await apiClient.post('/contacts/create', contactData);
  return response.data;
};

export const updateContact = async (id, contactData) => {
  const response = await apiClient.put(`/contacts/${id}`, contactData);
  return response.data;
};

export const deleteContact = async (id) => {
  const response = await apiClient.delete(`/contacts/${id}`);
  return response.data;
};

export const sendContactPrivacyNotice = async (id) => {
  const response = await apiClient.post(`/contacts/${id}/send-privacy-notice`);
  return response.data;
};

export const sendContactCampaignAccessLink = async (id, payload = {}) => {
  const response = await apiClient.post(`/contacts/${id}/send-campaign-access-link`, payload);
  return response.data;
};

export const getPrivacyConsentToken = async (token) => {
  const response = await apiClient.get(`/contacts/privacy-consent/${encodeURIComponent(token)}`);
  return response.data;
};

export const respondToPrivacyConsent = async (token, decision) => {
  const response = await apiClient.post(`/contacts/privacy-consent/${encodeURIComponent(token)}/respond`, {
    decision,
  });
  return response.data;
};

export const getCampaignAccessToken = async (token) => {
  const response = await apiClient.get(`/contacts/campaign-access/${encodeURIComponent(token)}`);
  return response.data;
};

export const submitCampaignAccessFeedback = async (token, payload = {}) => {
  const response = await apiClient.post(`/contacts/campaign-access/${encodeURIComponent(token)}/feedback`, payload);
  return response.data;
};

export const activateCampaignAccessToken = async (token, payload = {}) => {
  const response = await apiClient.post(`/contacts/campaign-access/${encodeURIComponent(token)}/activate`, payload);
  return response.data;
};

export const requestCampaignAccessDeviceRestart = async (token, payload = {}) => {
  const response = await apiClient.post(`/contacts/campaign-access/${encodeURIComponent(token)}/control/restart`, payload);
  return response.data;
};
